export default "__VITE_ASSET__DR0S61aE__"